import React, {createContext, useState} from "react";
import FormSubmissionServices from "../services/FormSubmissionServices";
import Notification from "../components/common/Notification";

export const FormSubmissionContext = createContext("FormSubmissionContext");

const FormSubmissionContextProvider = ({children}) => {

    const [loading, setLoading] = useState(false);
    const [errorMsg, setErrorMsg] = useState("");

    const [totalElements, setTotalElements] = useState(0);
    const [formSubmissions, setFormSubmissions] = useState(null);

    const generateFormSubmissionExcelReport = async (params) => {
        try {
            setLoading(true);
            setErrorMsg("");
            const res = await FormSubmissionServices.generateFormSubmissionExcelReport(params);
            if (res) {
                const url = window.URL.createObjectURL(new Blob([res.data]));
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", res.headers["content-disposition"].split("filename=")[1]);
                document.body.appendChild(link);
                link.click();
            }
            setLoading(false);
            return res.data;
        } catch (error) {
            setLoading(false);

            let _error = "Something went wrong.";

            if (error.message === "Network Error") {
                _error = error.message;
            }

            console.log("error ", error)
            if (error.response && error.response.data) {
                _error = error.response.data.message;
            }

            Notification("error", "ERROR", `${_error}`);
            return false;
        }
    };

    // const getAllFormSubmissions = async (params) => {
    //     try {
    //         setLoading(true);
    //         setErrorMsg("");

    //         const res = await FormSubmissionServices.getAllFormSubmissions(params);

    //         setFormSubmissions(res.data.content);
    //         setTotalElements(res.data.totalElements);
    //         setLoading(false);

    //         return true;
    //     } catch (error) {
    //         setLoading(false);

    //         let _error = "Something went wrong.";

    //         if (error.message === 'Network Error') {
    //             _error = error.message;
    //         }

    //         if (error.response && error.response.data) {
    //             _error = error.response.data.message;
    //         }

    //         setErrorMsg(_error);
    //         Notification("error", "ERROR", `${_error}`);
    //         return false;
    //     }
    // }

    return (
        <FormSubmissionContext.Provider
            value={{
                loading,
                errorMsg,
                totalElements,
                formSubmissions,
                generateFormSubmissionExcelReport,
                // getAllFormSubmissions,
            }}
        >
            {children}
        </FormSubmissionContext.Provider>
    );
};

export default FormSubmissionContextProvider;
